/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function theInsiderChange(form, action_type){
  var previousId = $(form).find(".interiorMatsSize").val();

  console.log('action_type: '+action_type);
  // Styles start

  var shop_classOne = $(form).find('input[type="radio"]:checked').attr('item-data');
  var shop_classTwo = $(form).find('.interiorMatsStyle option:selected').attr('data-style');
  var shop_classThree = $(form).find('.interiorMatsSize option:selected').attr('data-size');
  //console.log('shop_classOne:'+shop_classOne);

  //console.log('shop_classThree:'+shop_classThree);

  $(form).find(".interiorMatsStyle > option").each(function() {
    $(this).removeClass("show-swatch");
    $(this).removeClass("hide-swatch");
    if( action_type == 'tabs' && $(this).hasClass(shop_classOne) ){
      $(this).addClass("show-swatch");
    }else if( action_type == 'style' && $(this).hasClass(shop_classOne) ){
      $(this).addClass("show-swatch");
    }else if( action_type == 'size' && $(this).hasClass(shop_classOne) ){
      $(this).addClass("show-swatch");
    }else{
      $(this).addClass("hide-swatch");
    }

  });
  // Styles end


  if( action_type == 'tabs' ){
    $(form).find(".interiorMatsStyle > option:selected").removeAttr("selected");
    $(form).find(".interiorMatsStyle > option.show-swatch").eq(0).prop('selected', true);
    var shop_classTwo = $(form).find('.interiorMatsStyle option:selected').attr('data-style');
  }
  //console.log('shop_classTwo:'+shop_classTwo);


  //Size start

  $(form).find(".interiorMatsSize > option").each(function() {
    $(this).removeClass("show-size");
    $(this).removeClass("hide-size");
    if( action_type == 'tabs' && $(this).hasClass(shop_classOne) && $(this).hasClass(shop_classTwo) ){
      $(this).addClass("show-size");
    }else if( action_type == 'size' && $(this).hasClass(shop_classOne) && $(this).hasClass(shop_classTwo) ){
      $(this).addClass("show-size");
    }else if( action_type == 'style' && $(this).hasClass(shop_classOne) && $(this).hasClass(shop_classTwo) ){
      $(this).addClass("show-size");
    }else{
      $(this).addClass("hide-size");
    }

  });

  //Size end

  if( action_type == 'tabs' ){

    $(form).find(".interiorMatsStyle > option:selected").removeAttr("selected");
    $(form).find(".interiorMatsSize > option:selected").removeAttr("selected");

    $(form).find(".interiorMatsStyle > option.show-swatch").first().attr('selected', 'selected');
    $(form).find(".interiorMatsStyle > option.show-swatch").first().prop('selected', true);
    $(form).find(".interiorMatsSize > option.show-size").first().prop("selected", true);

  }else if( action_type == 'style' ){

    $(form).find(".interiorMatsSize > option:selected").removeAttr("selected");
    $(form).find(".interiorMatsSize > option.show-size").first().prop("selected", true);


  }else if( action_type == 'size' ){

    $(form).find(".interiorMatsStyle > option:selected").removeAttr("selected");
    $(form).find(".interiorMatsStyle > option.show-swatch").first().prop('selected', true);

  }

  //for change image
  var data_image = $(form).find(".interiorMatsStyle > option:selected").attr('data-image');
  var data_price = $(form).find(".interiorMatsStyle > option:selected").attr('data-price');

  if(data_image){
    $('.tab-active').find(".product_image_show").removeAttr('data-srcset');
    $('.tab-active').find(".product_image_show").removeAttr('srcset');
    $('.tab-active').find(".product_image_show").attr("src", data_image);
  }
  //for change image

  //for change tag
  var style_option = $(form).find(".interiorMatsStyle > option:selected").attr('data-option');
  var size_option = $(form).find(".interiorMatsStyle > option:selected").attr('data-option-size');

  $(form).closest('div.FeaturedProduct').find(".interiorstyleUpdt").html(style_option);
  $(form).closest('div.FeaturedProduct').find(".interiorsizeUpdt").html(size_option);
  //for change tag


  //For change price
  $(form).find(".ProductForm__AddToCart .addtocart_price").html(data_price);
  //For change price





}
$(document).ready(function(){

  //for interior page

  $(".tab-b > input").change(function() {
    console.log($(this).attr("id"));

    var productFormOne = $(this).closest('form');
    theInsiderChange(productFormOne, 'tabs');

  });

  $(".tab .interiorMatsStyle").change(function() {
    var productFormOne = $(this).closest('form');
    theInsiderChange(productFormOne, 'style');
  });

  $(".tab .interiorMatsSize").change(function() {

    var productFormOne = $(this).closest('form');
    theInsiderChange(productFormOne, 'size');

  });


  // interior get inspired link in top
  if ( jQuery(window).width() < 585) {
    jQuery('.getinspire > a').click(function(e){
      e.preventDefault();
      jQuery('body, html').animate({
        scrollTop: $('#shopify-section-product-landing-interior').offset().top - 200
      }, 1000);
    });
  }
  else{
    jQuery('.getinspire > a').click(function(e){
      e.preventDefault();
      jQuery('body, html').animate({
        scrollTop: $('#shopify-section-product-landing-interior').offset().top - 150
      }, 1000);
    });
  }

  if ( jQuery(window).width() < 585) {
    jQuery('.shop_inspired').click(function(e){
      e.preventDefault();
      jQuery('body, html').animate({
        scrollTop: $('#shopify-section-product-landing-interior').offset().top - 200
      }, 1000);
    });
  }
  else{
    jQuery('.shop_inspired').click(function(e){
      e.preventDefault();
      jQuery('body, html').animate({
        scrollTop: $('#shopify-section-product-landing-interior').offset().top - 150
      }, 1000);
    });
  }

  //for interior page



  $(".addtocartButton > form, .addtocartForm > form").submit(function(e){
    var addToCartButton = $(this).find('.ProductForm__AddToCart');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    e.preventDefault();

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $( this ).serialize(),
      dataType: 'json',
      success: function(dataObj) { 
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: dataObj.variant_id,
            quantity: dataObj.quantity
          }
        }));

      },

      error: function(errorObj) { 
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        //var addToCartButton = $(this).find('.ProductForm__AddToCart');
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        console.log(errorObj.responseJSON.description);
        errorMessageElement.innerHTML = errorObj.responseJSON.description;
        $(addToCartButton).hide();
        $(addToCartButton).after(errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
          $(addToCartButton).show();
        }, 2500);
      }
    });


    return false;

  });

  $(".ColorSwatch__Radio").change(function(){
    $(this).parent().parent().find('.ProductItem__ColorSwatchItem').removeClass('swatch-selected');
    $(this).parent('.ProductItem__ColorSwatchItem').addClass('swatch-selected');
    var variant_name = $(this).attr('name');
    var variant_id = $('.ColorSwatch__Radio[name="'+variant_name+'"]:checked').attr('data-variant-id');
    //$(this).closest('form').find('select[name="id"] option[value="'+variant_id+'"]').prop('selected', true);
    $(this).closest('form').find('input[name="id"]').val(variant_id);
    console.log(variant_id);
  });

  $(".ProductItem__ColorSwatchItem").click(function(){
    console.log("called");
    $(this).closest('form').find('.ProductItem__ColorSwatchItem').removeClass('swatch-selected');
    $(this).addClass('swatch-selected');
    var img_url_replace = $(this).find('input').attr( "data-image-url" );
    console.log(img_url_replace);
    $(this).closest('.ProductItem').find('a').find('img').removeAttr('data-srcset');
    $(this).closest('.ProductItem').find('a').find('img').removeAttr('srcset');
    $(this).closest('.ProductItem').find('a').find('img').attr('data-src',img_url_replace);
    $(this).closest('.ProductItem').find('a').find('img').attr('src',img_url_replace);


  });

});

function addCartItemToCart(variantId){
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  //console.log(variantId);
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {id: variantId, quantity:1},
    dataType: 'json',
    success: function(dataObj) {

      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: dataObj.variant_id,
          quantity: dataObj.quantity
        }
      }));

    }
  });
}



// $(".sizeSelection-js").change(function(){
// //     $(this).parent().parent().find('.ProductItem__ColorSwatchItem').removeClass('swatch-selected');
// //     $(this).parent().addClass('swatch-selected');
// //   	var variant_name = $(this).attr('name');
//     var variant_id = $('.ColorSwatch__Radio[name="'+variant_name+'"]:checked').attr('data-variant-id');
//     //$(this).closest('form').find('select[name="id"] option[value="'+variant_id+'"]').prop('selected', true);
//     $(this).closest('form').find('input[name="id"]').val(variant_id);
//     console.log(variant_id);
//   });

//   $(".ProductItem__ColorSwatchItem").click(function(){
//   	console.log("called");
//   });

// });


// slider class
// collectionhomeSliderMobo

jQuery(document).ready( function() {
  /* Check width on page load*/
  if ( jQuery(window).width() < 991) {

    $('.collectionhomeSliderMobo').slick({
      //               swipeToSlide: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed:500,
      arrows:false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.3,
            infinite: false,
            slidesToScroll: 1,
            arrows:false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1.22,
            infinite: false,
            slidesToScroll: 1,
            arrows:false
          }
        }
      ]
    });

  }
  else {}

  if ( jQuery(window).width() < 876) {

    $('.mobointriar_tab').slick({
      //               swipeToSlide: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      speed:500,
      arrows:false,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            infinite: true,
            slidesToScroll: 1,
            arrows:false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2.5,
            infinite: true,
            slidesToScroll: 1,
            arrows:false
          }
        }
      ]
    });

  }
  else {}

  if ( jQuery(window).width() < 575) {

    $('#mobo_process').slick({
      //               swipeToSlide: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      speed:500,
      arrows:true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            infinite: false,
            slidesToScroll: 1,
            arrows:false,
          }
        },
        {
          breakpoint: 575,
          settings: {
            centerMode: true,
            infinite: true,
            centerPadding: '40px',
            slidesToShow: 1.8,
            speed: 500,
            variableWidth: false,
          }
        },
        {
          breakpoint: 420,
          settings: {
            centerMode: true,
            infinite: true,
            centerPadding: '69px',
            slidesToShow: 1,
            speed: 500,
            variableWidth: false,
          }
        }
      ]
    });

  }
  else {}



});

$( document ).ready(function() {
  $('.feature-main').marquee({
    direction: 'left',
    duration: 50000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
  });
});

$(document).ready(function() {
  $( document ).scroll(function () {

    $(window).scroll(function() {
      var $height = $(window).scrollTop();
      if($height > 1000) {
        $('.touchingheader').css('display','block');
      } else {
        $('.touchingheader').css('display','none');
      }
    });


  });
});


$(document).ready(function() {

  $('.Form_addcart').addClass("cust_sticky_btn");

  $( document ).scroll(function () {
    $(window).scroll(function() {
      var $height = $(window).scrollTop();
      if($height > 300) {
        $('.Form_addcart').removeClass("cust_sticky_btn");
      } else {
        $('.Form_addcart').addClass("cust_sticky_btn");
      }
    });
  });
});




jQuery( document ).ready(function() {
  setTimeout(function(){ 
    jQuery("#smile-ui-container").css("z-index", "999");
  }, 3000);
  $(window).on("scroll", () => {
               $("#shopify-section-landing-interior-top").each(function() {
    var offset = $(this).offset().top - $(window).scrollTop();
    if (offset <= 0) {
      $(this).addClass("touchingtop")
    }else {
      $(this).removeClass("touchingtop")
    }
  });
});
$(window).on("scroll", () => {
             $("#shopify-section-landing-exterior-top").each(function() {
  var offset = $(this).offset().top - $(window).scrollTop();
  if (offset <= 0) {
    $(this).addClass("touchingtop")
  }else {
    $(this).removeClass("touchingtop")
  }
});
});
});

jQuery( document ).ready(function() {
  jQuery("#close_siteLink").click(function(){
    jQuery(".sitelink-main").removeClass("show");
  });
  jQuery("#sitecredit__link").click(function(){
    jQuery(".sitelink-main").addClass("show");
  });
});

//   styling tips carousal 
jQuery(document).ready(function(){
  jQuery('.stylingSlider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    draggable: false,
    asNavFor: '.stylingSlider-nav'
  });
  jQuery('.stylingSlider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.stylingSlider-for',
    dots: false,
    draggable: false,
    focusOnSelect: true
  });
});

 jQuery('.styling-tips a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   jQuery('.stylingSlider-nav').slick('slickGoTo', slideno - 1);
 });


jQuery('.style_tipsTitle').click(function(e) {
  	e.preventDefault();
  
    let $this = jQuery(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
      	$this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .style_tipsInner').removeClass('show');
        $this.parent().parent().find('li .style_tipsInner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});



jQuery(document).ready(function() {
  setTimeout(ProductItem__ColorSizeList,500);
  function ProductItem__ColorSizeList(){
    jQuery(".pdSize-row.select-product-sizes").each(function () {
      var optionCheckSize = jQuery(".pdSize-row.select-product-sizes > option").length;
      jQuery(".availableSize").text(optionCheckSize)

      //       alert(optionCheckSize)
      // 	console.log(optionCheckSize);
    });
  }
});




// -----------------------------------------


function homeFeaturedChanged(productForm, type){

    var styles=$(productForm).find('.pdStyle-row option:selected').attr('data-style');
      $(productForm).find('.pdSize-row > option').removeClass('show-size');
      $(productForm).find('.pdSize-row > option').removeClass('hide-size');
      
      $(productForm).find('.pdSize-row > option').addClass('hide-size');
      
      $(productForm).find('.pdSize-row .'+styles).removeClass('hide-size');
      $(productForm).find('.pdSize-row .'+styles).addClass('show-size');
      
      $(productForm).find(".pdSize-row > option.show-size").eq(0).prop('selected', true);
        
      var size=$(productForm).find('.pdSize-row > option:selected').attr('data-size');
      var price=$(productForm).find('.pdSize-row > option:selected').attr('data-price');
      var variant_id = $(productForm).find('.pdSize-row').val();
      var FeaturedProduct = $(productForm).closest('.FeaturedProduct');
      $(productForm).find(".productPriceChange").html(price);
      
      
      $(FeaturedProduct).find('.custom-ft-gallery').removeClass('gallary-show');
      $(FeaturedProduct).find('.custom-ft-gallery').removeClass('gallary-hide');
      $(FeaturedProduct).find('.custom-ft-gallery').addClass('gallary-hide');
      
      $(FeaturedProduct).find('#product_gallary_'+variant_id).removeClass('gallary-hide').addClass('gallary-show');
  
  }
  $(document).ready(function(){
    
    $('.homeProductSection .pdStyle-row').change(function(){
    	var productForm = $(this).closest('form');
		homeFeaturedChanged(productForm, 'style'); 
    });
    
    $('.homeProductSection .pdSize-row').change(function(){
    	var productForm = $(this).closest('form');
      	var FeaturedProduct = $(productForm).closest('.FeaturedProduct');
      	var price=$(this).find('option:selected').attr('data-price');
      	$(productForm).find(".productPriceChange").html(price);
      
      	var variant_id = $(productForm).find('.pdSize-row').val();
      	$(FeaturedProduct).find('.custom-ft-gallery').removeClass('gallary-show');
      	$(FeaturedProduct).find('.custom-ft-gallery').removeClass('gallary-hide');
      	$(FeaturedProduct).find('.custom-ft-gallery').addClass('gallary-hide');
      	$(FeaturedProduct).find('#product_gallary_'+variant_id).removeClass('gallary-hide').addClass('gallary-show');
      
    });
 });